//frontend/src/dropdownMap/2Act3_dropdownFieldMapping.js

export const dropdownFieldsByIdx = {
    9: "SubActivity",
    10: "ConstructionStatus",
    16: "Gender",
    18: "PovertyLevel",
    19: "PWD",
    20: "OMCommittee",
    21: "OMFund",
};

export const dropdownOptions = {
    //internal values should match database stored values
    //LA and EN values are for display purpose

    SubActivity: {
        internal: ["accesstracks", "collection", "cooling", "dryer", "dryingfloor", "grinding_mill", "mill", "packing", "sorter", "threshers", "weighing"],
        LA: {
            "accesstracks": "ເສັ້ນທາງນ້ອຍ",
            "collection": "ສາງ",
            "cooling": "ລະບົບໃຫ້ຄວາມເຢັນ",
            "dryer": "ໂຮງອົບ",
            "dryingfloor": "ລານຕາກ",
            "grinding_mill": "ໂຮງບົດ",
            "mill": "ໂຮງສີ",
            "packing": "ຈຸດໃຫ້ບໍລິການຫຸ່ມຫໍ່ບັນຈຸພັນ",
            "sorter": "ໂຮງຄັດແຍກ",
            "threshers": "ຈັກປັນເຂົ້າ",
            "weighing": "ສະຖານີໃຫ້ບໍລິການຊັ່ງນໍ້າໜັກ"
        },
        EN: {
            "accesstracks": "Access tracks",
            "collection": "Collection center",
            "cooling": "Cooling system",
            "dryer": "Dryer",
            "dryingfloor": "Drying floor",
            "grinding_mill": "Grinding mill",
            "mill": "Mill",
            "packing": "Packing unit",
            "sorter": "Sorter",
            "threshers": "Thresher",
            "weighing": "Weighing station"
        }
    },

    ConstructionStatus: {
        internal: ["n", "r"],
        LA: { "n": "ສ້າງໃໝ່", "r": "ສ້ອມແປງຄືນ" },
        EN: { "n": "New construction", "r": "Renovation" }
    },

    Gender: {
        internal: ["Male", "Female"],
        LA: { "Male": "ຊາຍ", "Female": "ຍິງ" },
        EN: { "Male": "Male", "Female": "Female" }
    },

    PovertyLevel: {
        internal: ["p", "np"],
        LA: { "p": "P", "np": "NP" },
        EN: { "p": "P", "np": "NP" }
    },

    PWD: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    OMCommittee: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    },

    OMFund: {
        internal: ["no", "yes"],
        LA: { "no": "No", "yes": "Yes" },
        EN: { "no": "No", "yes": "Yes" }
    }
};

// Reverse mapping: LA/EN display label -> internal DB value
export const dropdownReverseMap = {};
Object.keys(dropdownOptions).forEach(field => {
    dropdownReverseMap[field] = { LA: {}, EN: {} };
    const opts = dropdownOptions[field];
    opts.internal.forEach(intVal => {
        const strVal = String(intVal);
        dropdownReverseMap[field].LA[opts.LA[strVal]] = strVal;
        dropdownReverseMap[field].EN[opts.EN[strVal]] = strVal;
    });
});
